module.exports = __webpack_public_path__ + "static/media/youtube.434c6504.svg";